export default class Item {
    constructor(slug,type, look, reference, description, seasonSlug, seasonName, seasonShortname, designerSlug, designerName, designerDetails, badge, worn, page, medias, tags, likedBy, customFields) {
        this.slug = slug;
        this.type = type;
        this.look = look;
        this.reference = reference;
        this.description = description;
        this.seasonSlug = seasonSlug;
        this.seasonName = seasonName;
        this.seasonShortname = seasonShortname;
        this.designerSlug = designerSlug;
        this.designerName = designerName;
        this.designerDetails = designerDetails;
        this.badge = badge;
        this.worn = worn;
        this.page = page;
        this.medias = [];
        this.addMedias(medias);
        this.tags = tags;
        this.likedBy = likedBy;
        this.customFields = customFields;
    }

    get page() {
        return this._page;
    }

    set page(value) {
        this._page = parseInt(value);
    }

    get details() {
        if (this.reference) {
            return this.reference;
        }

        if (this.look) {
            const lookLabel = Translator.trans('results.look');

            return lookLabel.length === 0
                ? this.look
                : `${lookLabel} ${this.look}`;
        }

        return '';
    }

    static initFromJsonLd(object) {
        return new Item(
            object[0].identifier,
            object[0].additionalType,
            object[3].look,
            object[3].reference,
            object[0].description,
            object[1].identifier,
            object[1].name,
            object[1].alternateName,
            object[2].identifier,
            object[2].name,
            object[3].designerDetails,
            object[3].badge,
            object[3].worn,
            object[3].page,
            object[0].associatedMedia,
            object[3].tags,
            object[3].likedBy,
            object[3].custom
        );
    }

    addMedias(medias) {
        medias.map(media => {
            if (media.hasOwnProperty('contentUrl')) {
                const medias = {
                    'view': media.contentUrl['view'],
                    'list': media.contentUrl['list'],
                    'embed': false,
                    'courtesy': media?.copyrightNotice
                };
                if (media.contentUrl['zoom']) {
                    medias['zoom'] = media.contentUrl['zoom'];
                }
                this.medias.push(medias);
            } else {
                this.medias.push({
                    'url': media.embedUrl,
                    'embed': true,
                    'courtesy': media?.copyrightNotice
                })
            }
        })
    }
}
